/**
 * Whose Agent this face belongs to, by name.
 *
 * The shell learns an Agent's name from two places and no third: the directory
 * above it (`/api/hub/agents`) and what a plugin declared. This process serves
 * one Agent and has never been told what it is called, so the name comes from
 * the directory -- and where there is no directory there is no name, and the
 * head says 「Agent」, the same word the conversation dock already uses.
 *
 * Asked once per page load rather than once per face: a board of tiles mounts
 * one head per tile, and a fetch per tile for one unchanging string is a storm.
 * The answer is cached as the promise, so N heads share one request.
 */

import { AGENT_ID } from "../lib/base";
import { hubAgents } from "../lib/api";

/** What a head says when the shell has no name to say. */
export const UNNAMED_AGENT = "创作助手";

let asked: Promise<string> | null = null;

export function surfaceAgentName(): Promise<string> {
  asked ??= hubAgents()
    .then(agents => agents?.find(agent => agent.id === AGENT_ID)?.name || UNNAMED_AGENT)
    .catch(() => UNNAMED_AGENT);
  return asked;
}
